import React, { useState, useEffect } from "react";
import { Tabs, Tab, Dialog, DialogTitle, DialogContent, Typography, Button, DialogActions } from "@material-ui/core";
import { DetailedBooking, getBookingDetails } from "api/admin/bookings";
import i18n from "../i18n";
import ParticipantsTab from "./ParticipantsTab";
import StreamingStatsTab from "./StreamingStatsTab";

// prop types
interface BookingDetailDialogProps {
    bookingId: string | null,
    show: boolean,
    onClose: () => void,
    onRefreshBookingsTable: () => void,
}

// details booking dialog
const BookingDetailDialog = ({ bookingId, show, onClose, onRefreshBookingsTable }: BookingDetailDialogProps) => {
    // ui state
    const [booking, setBooking] = useState<DetailedBooking>();
    const [currentTab, setCurrentTab] = useState(0);

    // reset ui
    const fetchBooking = async (id: string) => setBooking(await getBookingDetails({ bookingId: id }));
    useEffect(() => { if (bookingId) { fetchBooking(bookingId); setCurrentTab(0); } }, [bookingId]);

    // refresh booking
    const refreshBooking = () => {
        fetchBooking(booking!.id);
        onRefreshBookingsTable();
    };

    // render
    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            open={show}
            onClose={onClose}
        >
            <DialogTitle disableTypography style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", padding: "0" }}>
                <Typography variant="h6" style={{ padding: "16px 24px" }}>{i18n.bookingDetails}</Typography>

                {/* tabs */}
                <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    value={currentTab}
                    onChange={(e, index) => setCurrentTab(index)}
                >
                    <Tab label={i18n.participants} />
                    {booking?.optionsInfo.possibleOptions.includes("get-session-stats") && <Tab label={i18n.streamingStats} />}
                </Tabs>
            </DialogTitle>
            <DialogContent dividers>
                {currentTab === 0 && <ParticipantsTab booking={booking} onRefreshBooking={refreshBooking} />}
                {currentTab === 1 && <StreamingStatsTab bookingId={bookingId} />}
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={onClose}>
                    {i18n.ok}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BookingDetailDialog;
